import React from 'react';
import { NumericFormat } from 'react-number-format';

export function WidgetPrice ({
    number,
    textAlign = 'right',
    width = '120px',
    showPrefix = true,
    showDecimals = true,
    style = {}
}) {
    return (
        <NumericFormat
            value={number}
            prefix={showPrefix ? '$' : ''}
            defaultValue={'-'}
            readOnly
            thousandSeparator="."
            style={{
                border: 'none',
                background: 'inherit',
                textAlign,
                width,
                maxWidth: width,
                ...style
            }}
            decimalSeparator=','
            allowNegative={true}
            decimalScale={showDecimals ? 2 : 0}
            fixedDecimalScale={showDecimals}
        />
    );
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetPrice.displayName = 'WidgetPrice';
}
